import React from "react";
import { usCurrency } from "../../../utils";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInfoCircle } from "@fortawesome/pro-light-svg-icons";
import { Col, Row } from "react-bootstrap";

const InvestmentCard = ({ data }) => {
  return (
    <>
      {data &&
        data.map((item) => (
          <div
            className={
              item.restricted
                ? "source-investment-card-restricted mt-2"
                : "source-investment-card mt-2"
            }
          >
            <div className="d-flex justify-content-between plr-10">
              <div className="ft-14 fw-500 mb-3">{item.investmentName}</div>
            </div>

            <Row className="mb-1 plr-10">
              <Col lg={6}>
                <div className="ft-14 fw-500">{usCurrency(item.amount)}</div>
                <span className="ft-12 grey-text">Amount</span>
              </Col>
              <Col lg={6}>
                <div className="ft-14 fw-500">
                  {item.percentage?.toFixed(2)} %
                </div>
                <span className="ft-12 grey-text">Percentage</span>
              </Col>
            </Row>

            {item.restricted && (
              <div style={{ backgroundColor: "#cdcdcd", padding: "5px" }}>
                <FontAwesomeIcon
                  icon={faInfoCircle}
                  style={{ fontSize: "12px" }}
                  color="#828282"
                  className="mt-1 mr-1 ml-2"
                />
                <span className="ft-12">Restricted Investment</span>
              </div>
            )}
          </div>
        ))}
    </>
  );
};

export default InvestmentCard;
